import { Injectable } from "@angular/core";
import Dexie from 'dexie';
import { Certification } from "../entities/certification";
import { CertificationInput } from "../entities/certification-input";
import { CertificationItem } from "../entities/certification-item";
import { Project } from "../entities/project";
import { Progress } from "../entities/progress";
import { ProgressItem } from "../entities/progress-item";
import { Road } from "../entities/road";
import { User } from "../entities/user";
import { SyncData } from "../entities/sync-data";
import { SyncLog } from "../entities/sync-log";

@Injectable({
  providedIn: 'root'
})
export class LocalDbService extends Dexie {
    certificationsTable!: Dexie.Table<Certification, string>;
    certificationInputsTable!: Dexie.Table<CertificationInput, number>;
    certificationItemsTable!: Dexie.Table<CertificationItem, string>;
    progressesTable!: Dexie.Table<Progress, string>;
    progressItemsTable!: Dexie.Table<ProgressItem, string>;
    projectsTable!: Dexie.Table<Project, number>;
    roadsTable!: Dexie.Table<Road, number>;
    userTable!: Dexie.Table<User, string>;
    syncDataTable!: Dexie.Table<SyncData, string>;
    syncLogsTable!: Dexie.Table<SyncLog, number>;

    constructor() {
        super('RoadsProjectManagementDb');

        this.version(1).stores({
            projectsTable: 'projectId, vendorId, supervisorId',
        });

        this.version(2).stores({
            projectsTable: 'projectId, vendorId, supervisorId',
            userTable: 'email, id',
        });

        this.version(3).stores({
            projectsTable: 'projectId, vendorId, supervisorId',
            userTable: 'email, id',
            syncDataTable: 'id',
        });

        this.version(4).stores({
            projectsTable: 'projectId, vendorId, supervisorId',
            roadsTable: 'id, projectId',
            userTable: 'email, id',
            syncDataTable: 'id',
        });

        this.version(5).stores({
            projectsTable: 'projectId, vendorId, supervisorId',
            roadsTable: 'id, projectId',
            userTable: 'email, id',
            syncDataTable: 'id',
        });

        this.version(6).stores({
            certificationsTable: 'id, projectId, roadId, userId, originId',
            certificationInputsTable: 'id, projectId, roadId, activityReportId, resourceId',
            certificationItemsTable: 'id, activityReportId, activityId',
            projectsTable: 'projectId, vendorId, supervisorId',
            roadsTable: 'id, projectId',
            userTable: 'email, id',
            syncDataTable: 'id',
        });

        this.version(7).stores({
            certificationsTable: 'id, projectId, roadId, userId, originId',
            certificationInputsTable: 'id, projectId, roadId, activityReportId, resourceId',
            certificationItemsTable: 'id, activityReportId, activityId',
            progressesTable: 'id, projectId, roadId, userId, originId',
            projectsTable: 'projectId, vendorId, supervisorId',
            roadsTable: 'id, projectId',
            userTable: 'email, id',
            syncDataTable: 'id',
        });

        this.version(8).stores({
            certificationsTable: 'id, projectId, roadId, userId, originId',
            certificationInputsTable: 'id, projectId, roadId, activityReportId, resourceId',
            certificationItemsTable: 'id, activityReportId, activityId',
            progressesTable: 'id, projectId, roadId, userId, originId',
            progressItemsTable: 'id, activityReportId, activityId',
            projectsTable: 'projectId, vendorId, supervisorId',
            roadsTable: 'id, projectId',
            userTable: 'email, id',
            syncDataTable: 'id',
        });

        this.version(9).stores({
            certificationsTable: 'id, projectId, roadId, userId, originId',
            certificationInputsTable: 'id, projectId, roadId, activityReportId, resourceId',
            certificationItemsTable: 'id, activityReportId, activityId',
            progressesTable: 'originId, id, projectId, roadId, userId',
            progressItemsTable: 'id, activityReportId, activityId',
            projectsTable: 'projectId, vendorId, supervisorId',
            roadsTable: 'id, projectId',
            userTable: 'email, id',
            syncDataTable: 'id',
        });

        this.version(10).stores({
            certificationsTable: 'id, projectId, roadId, userId, originId',
            certificationInputsTable: 'id, projectId, roadId, activityReportId, resourceId',
            certificationItemsTable: 'id, activityReportId, activityId',
            progressesTable: 'originId, id, projectId, roadId, userId',
            progressItemsTable: 'localId, id, activityReportId, activityId',
            projectsTable: 'projectId, vendorId, supervisorId',
            roadsTable: 'id, projectId',
            userTable: 'email, id',
            syncDataTable: 'id',
        });

        this.version(11).stores({
            certificationsTable: 'originId, id, projectId, roadId, userId',
            certificationInputsTable: 'id, projectId, roadId, activityReportId, resourceId',
            certificationItemsTable: 'id, activityReportId, activityId',
            progressesTable: 'originId, id, projectId, roadId, userId',
            progressItemsTable: 'localId, id, activityReportId, activityId',
            projectsTable: 'projectId, vendorId, supervisorId',
            roadsTable: 'id, projectId',
            userTable: 'email, id',
            syncDataTable: 'id',
        });

        this.version(12).stores({
            certificationsTable: 'originId, id, projectId, roadId, userId',
            certificationInputsTable: 'id, projectId, roadId, activityReportId, resourceId',
            certificationItemsTable: 'localId, id, activityReportId, activityId',
            progressesTable: 'originId, id, projectId, roadId, userId',
            progressItemsTable: 'localId, id, activityReportId, activityId',
            projectsTable: 'projectId, vendorId, supervisorId',
            roadsTable: 'id, projectId',
            userTable: 'email, id',
            syncDataTable: 'id',
        });

        this.version(13).stores({
            certificationsTable: 'originId, id, projectId, roadId, userId',
            certificationInputsTable: 'id, projectId, roadId, activityReportId, resourceId',
            certificationItemsTable: 'localId, id, activityReportId, activityId',
            progressesTable: 'originId, id, projectId, roadId, userId',
            progressItemsTable: 'localId, id, activityReportId, activityId',
            projectsTable: 'projectId, vendorId, supervisorId',
            roadsTable: 'id, projectId',
            userTable: 'email, id',
            syncDataTable: 'id',
            syncLogsTable: '++id, originId, action, createdAt',
        });

        this.certificationsTable = this.table('certificationsTable');
        this.certificationInputsTable = this.table('certificationInputsTable');
        this.certificationItemsTable = this.table('certificationItemsTable');
        this.progressesTable = this.table('progressesTable');
        this.progressItemsTable = this.table('progressItemsTable');
        this.projectsTable = this.table('projectsTable');
        this.roadsTable = this.table('roadsTable');
        this.userTable = this.table('userTable');
        this.syncDataTable = this.table('syncDataTable');
        this.syncLogsTable = this.table('syncLogsTable');
    }
}
